module.exports = __webpack_public_path__ + "img/London_Map_cropped.e7fd5fce.jpg";